import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';

@Component({
  selector: 'app-question-menu',
  templateUrl: './question-menu.component.html',
  styleUrls: ['./question-menu.component.scss']
})
export class QuestionMenuComponent implements OnInit {

  public expandMenu = this.dataSvc.expandMenu;
  

  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) { }

  ngOnInit() {
  }

}
